// Constants
import { GOAL_GROUP } from '@src/common/constants';

// Types
import { TPoints } from '@src/common/types/points';

export function isGoalPoint(point: TPoints): boolean {
  return GOAL_GROUP.has(point.type);
}
